import Vue from 'vue';

Vue.component('agreement-index', require('./components/aggrement/Index').default);
Vue.component('agreement-tab', require('./components/aggrement/Aggrement').default);
Vue.component('agreement-accredittation-tab', require('./components/aggrement/AggrementAccreditation').default);
Vue.component('agreement-modal', require('./components/aggrement/Modal').default);
Vue.component('agreement-accredittation-modal', require('./components/aggrement/AggrementAccreditationModal').default);



